import InitialNavbar from './InitialNavbar'

export default InitialNavbar
